import React, { useMemo } from 'react';
import classNames from 'classnames';
import { Resizable } from 're-resizable';
import { Button } from 'antd';
import { CodeOutlined, LeftOutlined } from '@ant-design/icons';

import QueryExposureModal from '../../../containers/funnel/side/QueryExposureModal';
import isFunnelReadyToExecute from '../../../utils/funnel';
import CompoundSideListItem from './ListItem';
import CompoundSideListSearch from './ListSearch';
import CompoundSideActionButtons from './ActionButtons';

const MIN_CONTAINER_WIDTH = 350;

const containerResizeButton = (containerWidth, setContainerWidth) => (
  <div
    style={{
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: 14,
    }}
  >
    <Button
      style={{
        width: containerWidth > MIN_CONTAINER_WIDTH ? '100%' : 0,
      }}
      data-container-resize-button
      onClick={(e) => {
        setContainerWidth(MIN_CONTAINER_WIDTH);
        // для гашения фокуса после нажатия
        e.target.blur();
      }}
    >
      <LeftOutlined
        style={{
          marginTop: 0,
          fontSize: containerWidth > MIN_CONTAINER_WIDTH ? 14 : 0,
        }}
      />
    </Button>
  </div>
);

const CompoundSideListItems = ({
  onSearch,
  onPreview,
  onUpdate,
  onDelete,
  onDuplicate,
  searchedItem,
  items,
  selectedItem,
  hasPermission,
  children,
  scrolTo,
  setContainerWidth,
  containerWidth,
  showExposureSQLButton,
}) => {
  const evenCount = !(items.length % 2);

  const sortedItems = useMemo(() => {
    return [...items].sort((a, b) => {
      return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1;
    });
  }, [items]);

  const renderItem = (item) => {
    const renderButton = (onClick, updatingFunnel) => (
      <Button
        icon={<CodeOutlined />}
        style={{ border: 'none', backgroundColor: 'transparent' }}
        onClick={(e) => {
          onPreview(item);
          onClick();
          e.target.blur();
        }}
        disabled={!isFunnelReadyToExecute(item, updatingFunnel)}
      />
    );

    return (
      <CompoundSideListItem
        key={item.id}
        item={item}
        active={item.id === selectedItem?.id}
        onPreview={onPreview}
      >
        {hasPermission && (
          <CompoundSideActionButtons
            item={item}
            onUpdate={onUpdate}
            onDelete={onDelete}
            onDuplicate={onDuplicate}
          >
            {showExposureSQLButton && <QueryExposureModal button={renderButton} />}
          </CompoundSideActionButtons>
        )}
      </CompoundSideListItem>
    );
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }}>
      <Resizable
        handleStyles={{
          right: {
            right: '0px',
            cursor: 'ew-resize',
            borderRight: '2px solid #1890ff',
            marginLeft: -5,
          },
        }}
        minHeight="100%"
        minWidth={MIN_CONTAINER_WIDTH}
        size={{ width: containerWidth }}
        defaultSize={{
          height: '100%',
        }}
        onResizeStop={(e, direction, ref, d) => {
          setContainerWidth(containerWidth + d.width);
        }}
        enable={{
          top: false,
          right: true,
          bottom: false,
          left: false,
          topRight: false,
          bottomRight: false,
          bottomLeft: false,
          topLeft: false,
        }}
      >
        <div className="st-compound-side-list">
          <CompoundSideListSearch onChange={onSearch} value={searchedItem} scrolTo={scrolTo} />
          <div
            style={{ height: 'calc(100vh - 139px)' }}
            className={classNames('items', { even: evenCount }, { odd: !evenCount })}
          >
            {sortedItems.map(renderItem)}
          </div>
          {children}
        </div>
      </Resizable>
      {containerResizeButton(containerWidth, setContainerWidth)}
    </div>
  );
};

export default CompoundSideListItems;
